"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var AttentionIcon = function AttentionIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "100",
    height: "99",
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter0_d_318_681)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 41.3851C20 57.614 33.4295 70.7701 49.9956 70.7701C52.0704 70.7701 54.0961 70.5638 56.0523 70.1708L79.9122 43.5343C79.9645 42.8246 79.9912 42.1079 79.9912 41.3851C79.9912 25.1561 66.5617 12 49.9956 12C33.4295 12 20 25.1561 20 41.3851Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.287 69.959L79.7473 43.7842C79.8481 43.6716 79.7976 43.4975 79.6492 43.4704C77.992 43.1682 70.197 42.181 63.0037 48.6214C55.7602 55.1067 55.8494 67.3324 55.9495 69.849C55.9565 70.025 56.1692 70.0904 56.287 69.959Z",
    fill: "url(#paint0_linear_318_681)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50 46V31",
    stroke: "#D13939",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50 53L50 52",
    stroke: "#D13939",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter0_d_318_681",
    x: "0",
    y: "0",
    width: "99.9911",
    height: "98.7701",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/_react.default.createElement("feOffset", {
    dy: "8"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    stdDeviation: "10"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.886719 0 0 0 0 0.903646 0 0 0 0 0.9375 0 0 0 1 0"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_318_681"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_318_681",
    result: "shape"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint0_linear_318_681",
    x1: "67.3942",
    y1: "56.8286",
    x2: "58.5504",
    y2: "48.084",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#D9DEE8"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#FDFDFD"
  }))));
};
var _default = AttentionIcon;
exports.default = _default;